module.exports = __webpack_public_path__ + "static/ahmad-50a9136bc462fd90d71a50750adda1e2.mp4";